import { createContext, useContext } from 'react';
import { RegistrationStep } from '../Utils/constants';

/** The two steps a visitor can open the overlay on; CompleteProfile is only ever reached from them. */
export type DfcAuthOverlayStep = RegistrationStep.Login | RegistrationStep.SignUp;

export interface DfcAuthOverlayContextProps {
  openAuth: (step: DfcAuthOverlayStep) => void;
}

/**
 * Opens the DFC Fitness Village sign in / create account panel over the current page — a
 * centred dialog from 960px, a bottom sheet below — instead of navigating to `/Register`.
 *
 * `undefined` outside `DfcAuthOverlayProvider`: callers go through `useDfcAuthEntry`, which
 * falls back to the `/Register` route, so nothing breaks where the provider is not mounted.
 */
export const DfcAuthOverlayContext = createContext<DfcAuthOverlayContextProps | undefined>(
  undefined
);

export const useDfcAuthOverlay = (): DfcAuthOverlayContextProps | undefined =>
  useContext(DfcAuthOverlayContext);
